import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Typography,
  TextField,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/HighlightOff";

export default function ReviewDialog({
  open,
  onClose,
  selected,
  reason,
  setReason,
  onApprove,
  onReject,
  reviewLoading,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Review Submission</DialogTitle>
      <DialogContent dividers>
        {selected && (
          <Stack spacing={1}>
            <Typography variant="subtitle2" color="text.secondary">
              {selected.type} / {selected.platform}
            </Typography>
            <Typography
              variant="body2"
              sx={{ wordBreak: "break-all" }}
              color="text.primary"
            >
              {selected.video_url}
            </Typography>
            <TextField
              label="Rejection Reason (optional)"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              fullWidth
              multiline
              minRows={2}
            />
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          startIcon={<CloseIcon />}
          color="error"
          onClick={onReject}
          disabled={reviewLoading}
        >
          Reject
        </Button>
        <Button
          startIcon={<CheckIcon />}
          variant="contained"
          onClick={onApprove}
          disabled={reviewLoading}
          sx={{ bgcolor: "brand.main", "&:hover": { bgcolor: "brand.dark" } }}
        >
          Approve
        </Button>
      </DialogActions>
    </Dialog>
  );
}
